import React from 'react';
import { Box, Chip, useTheme, alpha } from '@mui/material';

const ScrollBar = () => {
  const theme = useTheme();

  const tags = [
    'Beauty Manufacturing',
    'Product Development',
    'Quality Control',
    'Inventory Management',
    'Sales Analytics',
    'Production Planning',
    'Formulation Testing',
    'Supply Chain',
    'Brand Management',
    'Customer Insights',
    'Cost Optimization',
    'Regulatory Compliance',
    'Batch Tracking',
    'R&D Innovation',
    'Market Analysis',
    'Profit Maximization',
    'Operational Excellence',
    'Digital Transformation'
  ];

  // Duplicate tags for seamless loop
  const duplicatedTags = [...tags, ...tags];

  return (
    <Box sx={{ 
      width: '100%', 
      py: { xs: 2, sm: 2.5, md: 3 },
      mt: { xs: -8, sm: -12, md: -20 },
      bgcolor: alpha(theme.palette.grey[50], 0.8),
      overflow: 'hidden',
      position: 'relative'
    }}>
      <Box sx={{
        display: 'flex',
        gap: { xs: 2, sm: 2.5, md: 3 },
        animation: { xs: 'scroll 40s linear infinite', md: 'scroll 60s linear infinite' },
        width: 'max-content',
        '@keyframes scroll': {
          '0%': {
            transform: 'translateX(0)'
          },
          '100%': {
            transform: 'translateX(-50%)'
          }
        }
      }}>
        {duplicatedTags.map((tag, index) => (
          <Chip
            key={index}
            label={tag}
            sx={{
              fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' },
              fontWeight: 500,
              px: { xs: 2, sm: 2.5, md: 3 },
              py: { xs: 1, sm: 1.25, md: 1.5 },
              height: 'auto',
              borderRadius: { xs: 2, md: 3 },
              bgcolor: 'white',
              color: 'text.primary',
              border: `1px solid ${alpha(theme.palette.grey[300], 0.8)}`,
              boxShadow: `0 4px 12px ${alpha(theme.palette.grey[900], 0.08)}`,
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              whiteSpace: 'nowrap',
              cursor: 'default',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: `0 8px 20px ${alpha(theme.palette.primary.main, 0.15)}`,
                bgcolor: alpha(theme.palette.primary.main, 0.05),
                borderColor: alpha(theme.palette.primary.main, 0.3),
                color: 'primary.main'
              }
            }}
          />
        ))}
      </Box>
      
      {/* Gradient overlays for smooth fade effect */}
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: { xs: 60, sm: 80, md: 100 },
        height: '100%',
        background: `linear-gradient(to right, ${alpha(theme.palette.grey[50], 0.8)}, transparent)`,
        pointerEvents: 'none',
        zIndex: 1
      }} />
      <Box sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: { xs: 60, sm: 80, md: 100 },
        height: '100%',
        background: `linear-gradient(to left, ${alpha(theme.palette.grey[50], 0.8)}, transparent)`,
        pointerEvents: 'none',
        zIndex: 1
      }} />
    </Box>
  );
};

export default ScrollBar;